// 下户面谈表的可选字典数据
const maritalStatus = ['未婚', '初婚','再婚','复婚', '离婚', '丧偶']
const houseGetNode = ['婚前','婚内，离婚后', '丧偶']
const housePropertyType = ['单独所有', '共同所有', '按份共有']
const houseAddrEqOwnerCert = ['与房产证地址一致', '不一致']
const houseResidenceEqOwnerCert = ['与房产证地址一致', '不一致']
const locationCatalog = ['【A】东城区、西城区、朝阳区、丰台区、海淀区、崇文区、宣武区、石景山区', '【B】门头沟区、房山区、通州区、顺义区、昌平区、大兴区']
const houseEstateStatus = ['小区楼','散盘']
const decorate = ['精装修','中等装修','简装修','毛坯']
const houseElevatorStruct = ['有','无']
const houseFamilyRegister = ['是', '否']
const estateCertificate = ['是','否']
const houseNotWindowRoom = ['无','有']
const houseStructChange = ['是，影响居住', '是，不影响居住','否']
const houseRoughcastStatus = ['是', '否']
const borrowPurpose = ['经营周转', '借新还旧']
const youngOrOld = ['有','无']
const patient= ['有','无']
const propertyClear=['是','否']
const estateInherit=['买卖','赠予','建造','判决','继承','交换']
const toward=['东', '西', '南', '北', '东西', '东南', '东北', '西南', '西北', '南北通透']
const sealUp=['有','无']
const oldManChild = ['否', '未成年人','70岁以上老人','行动不便人员','精神疾病人员','智商障碍人员']
const houseAtTop = ['否','是']
const housePurpose = ['居住','宿舍', '办公', '仓储', '其他(  )']
const houseUseingStatus = ['自住', '空置', '出租，带租约','出租，无租约']
const houseRenantRelational = ['朋友', '亲戚', '陌生人']
const houseDecorateStatus = ['豪华', '一般', '较差']
const houseCohabitantRelation = ['父', '母','子女','亲戚','朋友','其他(  )']
const houseEleliftStruct = ['电梯', '楼梯']
const houseSpaceRoom = [' 房 厅 卫']
const houseOnlyResidence = ['是', '否']
const houseRafficSituation = ['有地铁站/公交站', '无地铁/有公交站', '无地铁/公交站', '其他']
const houseEnvPositive = ['有地铁站', '有公交站', '超市', '医院', '商圈', '学校']
const houseEnvNegative = ['无', '垃圾场', '化工厂', '高速公路', '殡仪馆', '墓地', '其他']
const leaseStatus = ['否', '有']
const comNature = ['国有企业（公司名称：  )', '事业单位(公司名称：  )', '外资企业(公司名称：  )', '民营企业(公司名称：  )', '自雇(公司名称：   )']
const comJob = ['高级领导', '中级领导', '一般员工', '其他( )']
const comIndustry = ['建筑业', '住宿餐饮业', '批发零售业', '文化体育娱乐业', '房地产', '租赁和商务服务', '农林牧渔', '采矿业', '制造业', '教育', '居民服务和其他服务', '公共管理与社会组织', '其他（  ）']
const comType = ['企业法人', '个体工商户']
const comOperateYears = ['1年以内', '1-5年', '6-10年', '10年以上']
const comToRelational = ['股东', '法人', '高管或职员', '其他(  )']
const familyIncome = ['10万元以下（含10万元）', '11-20万元', '21-30万元', '31-40万元', '41-50万元', '50万元-100万','100万以上']
const relendType = ['新增一押', '新增二押', '转贷一押','转贷二押']
const previousRepayStatus = ['正常', '有逾期']
const checkedCardID = ['身份证原件', '户口本原件','房产证原件','结婚证原件','离婚证原件','离婚协议','死亡证原件','征信原件','查册','其他( )']
// ----------------失效
const checkedFamilyRegister = ['已检查', '未检查']
const checkedPropertyCertificate = ['已检查', '未检查']
const checkedMarriageCertificate = ['未婚','结婚证', '离婚证', '离婚协议', '死亡证']
const checkedCreditReporting = ['已检查', '未检查']
const checkedPropertyRegister = ['已检查', '未检查']
const checkedOther = ['无', '其他(  )']
const repaymentSource = ['经营收入','工资收入','房屋租金收入','其他收入']
const ifOtherIncome= ['否','是']


//下户面谈
const industry = ['否', '是，'] // 是否为特殊职业
const domicile= ['否', '是，'] // 是否为外籍或港澳台
const customerOther= ['无', '有，'] // 借款人资料 - 其他应关注信息
const marriage=['未婚','已婚','丧偶','离异'] // 婚姻状况
const compensate=['有，','无'] // 是否存在离婚补偿
const children=['有，','无'] // 子女状况
const marriageOther=['无','有，'] // 婚姻状况 - 其他应关注情况
const source=['买卖','赠予','建造','判决','继承','交换'] // 房产取得方式
const quality = ['商品房', '成本价出售', '经济适用房', '按经济适用房管理'] // 房产性质
const isLease=['是','否'] // 是否出租 合同打印值
const onlyHouse= ['有，','无'] // 在京有无其他不动产
const otherConcerns=['无','有'] // 房产其他应关注信息
const overdue=['无','有(情况说明：)']
const moreThan3=['无','有(情况说明：)']
const abnormal=['无','有(情况说明：)']
const creditOther=['无','有']
const defendant=['无','有，'] // 客户及共借人是否有涉及借贷纠纷被告
const plaintiff=['无','有，'] // 客户及共借人是否有涉及借贷纠纷原告
const execute=['无','有，'] // 客户及共借人当前是否有涉诉或被执行信息（非借贷纠纷）
const economy=['无','有，'] // 客户经营主体及关联公司是否有经济纠纷
const judicialOther=['无','有，'] // 司法，其他应关注信息
const notarization=['是','否'] // 是否否公证
const riskAudit=['是(说明：)','否']
const audit=['通过(说明：)','拒绝(说明：)']
const assistantAudit=['通过(说明：)','拒绝(说明：)']
const operateAudit=['有(说明：)','无']
const live=['是(情况说明：)','否']
const realestateType=['普通住宅','别墅','商铺','商住公寓','公寓','写字楼','平房/四合院','其他']
const guarantyCertify=['房屋所有权证','国有土地使用证','不动产权证书','房地产权证']
const mortgageType=['一般抵押','最高额抵押']
const secondMortgageType=['一般抵押','最高额抵押']
const customerCooperation = ['高', '中', '低']
const decorateMap={
    "0":"精装修",
    "1":"中等装修",
    "2":"简装修",
    "3":"毛坯"
}
const leaseMap={
    'yes':'有',
    'no':'无'
}
const towardMap={
    "0":'东',
    "1":'西',
    "2":'南',
    "3":'北',
    "4":'东西',
    "5":'东南',
    "6":'东北',
    "7":'西南',
    "8":'西北',
    "9":'南北通透'
}
const houseOnlyResidenceMap={
    '0':'否',
    '1':'是'
}
const houseGetNodeMap={
    '1': '婚前',
    '2': '婚内',
    '3': '离婚后',
    '4':'丧偶'
}
const propertyTypeMap={
    "0":'单独所有',
    "1":'共同共有',
    "2":'按份共有',
}
const realestateTypeMap={
    '0':'普通住宅',
    '1':'别墅',
    '2':'商铺',
    '3':'商住公寓',
    '4':'公寓',
    '5':'写字楼',
    '6':'平房/四合院',
    '7':'其他'
}
const guarantyCertifyMap={
    '01':'房屋所有权证',
    '02':'国有土地使用证',
    '03':'不动产权证书',
    '04':'房地产权证'
}
const mortgageTypeMap={
    '01':'一般抵押',
    '02':'最高额抵押'
}

// 初审意见表的字段选值
const settlementIsRequired = ['是', '否'] // 是否需要结清
const associatedAdvances = ['是', '否'] // 是否关联大橙垫资
const mortgagePriority = ['一抵', '二抵', '三抵'] // 抵押顺位

// 聚合导出
export const dictData = {
    'maritalStatus': maritalStatus,
    'houseGetNode': houseGetNode,
    'housePropertyType': housePropertyType,
    'houseAddrEqOwnerCert': houseAddrEqOwnerCert,
    'houseResidenceEqOwnerCert': houseResidenceEqOwnerCert,
    'houseEstateStatus': houseEstateStatus,
    'houseFamilyRegister': houseFamilyRegister,
    'houseStructChange': houseStructChange,
    'houseRoughcastStatus': houseRoughcastStatus,
    'borrowPurpose': borrowPurpose,
    'oldManChild': oldManChild,
    'housePurpose': housePurpose,
    'houseUseingStatus': houseUseingStatus,
    'houseRenantRelational': houseRenantRelational,
    'houseDecorateStatus': houseDecorateStatus,
    'houseCohabitantRelation': houseCohabitantRelation,
    'houseEleliftStruct': houseEleliftStruct,
    'houseSpaceRoom': houseSpaceRoom,
    'houseEnvPositive': houseEnvPositive,
    'houseEnvNegative': houseEnvNegative,
    'comNature': comNature,
    'houseOnlyResidence': houseOnlyResidence,
    'houseAtTop': houseAtTop,
    'comJob': comJob,
    'comIndustry': comIndustry,
    'comType': comType,
    'comOperateYears': comOperateYears,
    'comToRelational': comToRelational,
    'familyIncome': familyIncome,
    'relendType': relendType,
    'previousRepayStatus': previousRepayStatus,
    'checkedCardID': checkedCardID,
    'checkedFamilyRegister': checkedFamilyRegister,
    'checkedPropertyCertificate': checkedPropertyCertificate,
    'checkedMarriageCertificate': checkedMarriageCertificate,
    'checkedCreditReporting': checkedCreditReporting,
    'checkedPropertyRegister': checkedPropertyRegister,
    'checkedOther': checkedOther,
    'customerCooperation': customerCooperation,
    'repaymentSource':repaymentSource,
    'ifOtherIncome':ifOtherIncome,
    'houseElevatorStruct':houseElevatorStruct,
    'decorate':decorate,
    'estateCertificate':estateCertificate,
    'houseNotWindowRoom':houseNotWindowRoom,
    'youngOrOld':youngOrOld,
    'patient':patient,
    'propertyClear':propertyClear,
    'estateInherit':estateInherit,
    'sealUp':sealUp,
    'toward':toward,
    //下户面谈
    'industry':industry,
    'domicile':domicile,
    'marriage':marriage,
    'customerOther':customerOther,
    'compensate':compensate,
    'children':children,
    'marriageOther':marriageOther,
    'source':source,
    'isLease':isLease,
    'onlyHouse':onlyHouse,
    'otherConcerns':otherConcerns,
    'overdue':overdue,
    'moreThan3':moreThan3,
    'abnormal':abnormal,
    'creditOther':creditOther,
    'defendant':defendant,
    'plaintiff':plaintiff,
    'execute':execute,
    'economy':economy,
    'judicialOther':judicialOther,
    'notarization':notarization,
    'riskAudit':riskAudit,
    'audit':audit,
    'assistantAudit':assistantAudit,
    'operateAudit':operateAudit,
    'live':live,
    'realestateType':realestateType,
    'guarantyCertify':guarantyCertify,
    'mortgageType':mortgageType,
    'secondMortgageType':secondMortgageType,
    //
    'decorateMap':decorateMap,
    'leaseMap':leaseMap,
    'towardMap':towardMap,
    'houseOnlyResidenceMap':houseOnlyResidenceMap,
    'houseGetNodeMap':houseGetNodeMap,
    'realestateTypeMap':realestateTypeMap,
    'guarantyCertifyMap':guarantyCertifyMap,
    'propertyTypeMap':propertyTypeMap,
    'propertyDesc': propertyTypeMap,
    'mortgageTypeMap': mortgageTypeMap,
    // 初审意见表
    'settlementIsRequired': settlementIsRequired,
    'associatedAdvances': associatedAdvances,
    'quality': quality,
    'locationCatalog': locationCatalog
}
